export const APPOINTMENTS_SORT = [
  'id',
  'scheduled_date',
  'scheduled_time',
  'slots',
  'carrier_id',
  'client_name',
  'department_id',
  'warehouse_id',
  'skids',
  'boxes',
  'created_by',
  'asn',
  'appointment_status_id',
  'updated_at',
]

export const BILL_SORT = ['id', 'client', 'year']

export const CLIENT_PRICING_SORT = [
  'id',
  'client_name',
  'billing_line_charge_id',
  'price',
  'effective_date',
  'revision_date',
]

export const RETURNS_SORT = [
  'id',
  'return_state_id',
  'warehouse_name',
  'client_name',
  'internal_order',
  'order_number',
  'date_returned',
  'date_processed',
  'return_reason_id',
  'return_status_id',
  'rma_number',
]

export const SHIPPING_SORT = [
  'id',
  'client_name',
  'batch_id',
  'internal_order',
  'order_number',
  'order_package_status_id',
  'location_name',
  'tracking',
  'carrier',
  'ship_date',
]

export const PURCHASE_ORDER_SORT = [
  'id',
  'client_name',
  'po_number',
  'internal_po',
  'status',
  'supplier_name',
  'warehouse_name',
  'purchase_order_condition_id',
  'created_at',
  'date_expected',
  'last_modified',
]

export const RECEIVING_SORT = [
  'id',
  'arrival_date',
  'arrival_time',
  'pallet_unloaded',
  'receiving_status_id',
  'supplier_name',
  'client_name',
  'carrier_id',
  'total_received_unit',
  'purchase_order_number',
  'receiving_state_id',
  'created_at',
  'updated_at',
]

export const CLIENTS_SORT = ['id', 'client_name', 'email', 'department', 'status', 'updated_at']

export const SUPPLIERS_SORT = ['id', 'name', 'email', 'client', 'status']

export const ITEMS_SORT = [
  'id',
  'sku',
  'client_name',
  'supply_type_id',
  'item_status_id',
  'updated_at',
  'base_uom_type_id',
]

export const INVENTORY_SORT = [
  'id',
  'sku',
  'client_name',
  'lot',
  'expiry_date',
  'warehouse_name',
  'location_name',
  'quantity_type_id',
  'item_reason_id',
  'quantity_each',
  'base_uom_type_id',
]

export const LOCATIONS_SORT = [
  'id',
  'name',
  'client_id',
  'warehouse_id',
  'location_id',
  'location_category_id',
  'location_type_id',
  'movable',
  'status',
  'permanent',
  'updated_at',
]

export const TRANSACTIONS_SORT = [
  'id',
  'client_id',
  'sku',
  'lot_1',
  'transaction_type_id',
  'batch_id',
  'order_number',
  'internal_order',
  'warehouse_id',
  'location_name_1',
  'location_name_2',
  'note',
  'updated_at',
]

export const RECEIVING_TRANSACTIONS_SORT = [
  'client_id',
  'sku',
  'created_at',
  'receiving_id',
  'purchase_order_id',
  'quantity_received_each',
  'lot',
  'quantity_type_id',
  'receiving_item_condition_id',
]

export const JOBS_SORT = [
  'id',
  'ticket_type_id',
  'warehouse_name',
  'start_time',
  'batch_id',
  'client_name',
  'picking_method_id',
  'user_name',
  'ticket_status_id',
  'created_at',
  'updated_at',
]

export const WAREHOUSES_SORT = [
  'id',
  'name',
  'country_id',
  'province_id',
  'order_processing',
  'status',
]

export const ORDERS_SORT = [
  'id',
  'client_name',
  'order_date',
  'order_number',
  'internal_order',
  'order_items',
  'order_status_id',
  'picking_method_id',
  'processing_type_id',
  'batch_id',
  'warehouse_name',
  'order_state_id',
  'company',
  'first_name',
  'postal_code',
  'carrier_id',
  'created_at',
  'updated_at',
]

export const USERS_SORT = ['id', 'first_name', 'last_name', 'email', 'production_user', 'status']

export const ZONES_SORT = [
  'id',
  'status',
  'warehouse_name',
  'employee',
  'zone_name',
  'zone_category_id',
]

export const ORDERS_LOG_SORT = [
  'order_id',
  'action',
  'previous_properties',
  'properties',
  'note',
  'created_by_name',
  'synch_status',
  'synch_message',
  'deleted_by',
  'created_at',
  'updated_at',
]

export const INVOICES_SORT = [
  'id',
  'invoice_status_id',
  'invoice_number',
  'account_manager',
  'warehouse_name',
  'client_name',
  'invoice_date',
  'currency_id',
  'subtotal_amount',
  'tax_amount',
  'total_amount',
]

export const COUNTRIES_SORT = ['id', 'iso_code_2', 'iso_code_3']

export const PROVINCES_SORT = ['id', 'code', 'country_id', 'status']

export const BILL_CATEGORIES_SORT = ['id', 'name']

export const UOM_SORT = ['id', 'name']

export const LINE_CHARGES_SORT = ['id', 'name']

export const PERMISSIONS_SORT = ['id', 'name']

export const ROLES_SORT = ['id', 'name']

export const LANGUAGES_SORT = ['id', 'name']

export const HOLIDAYS_SORT = ['id', 'name']

export const ERRORS_SORT = ['id', 'name']

export const DEPARTMENTS_SORT = ['id', 'name']

export const PLATFORMS_SORT = ['id', 'name']

export const CARRIERS_SORT = ['id', 'name']

export const SETTINGS_SORT = ['id', 'key', 'code']

export const INTEGRATION_LOGS_PARAMETER_SORT = ['executed_on', 'parameter', 'code']

export const TAX_RATES_SORT = ['id', 'amount']

export const TAX_CLASSES_SORT = ['id']
